/** The `$id` path param reaches the page as `router.query.id`; an unknown id redirects to /federal-tax in the page itself. */
import { createFileRoute } from '@tanstack/react-router'

import { FederalTaxDetailPage } from '@/features/federal-tax'

export const Route = createFileRoute('/_shell/federal-tax/$id')({ component: FederalTaxDetailPage })
